import { EmailOptInRepository } from '../repositories/EmailOptInRepository';
import { diContainer } from '../../service-setup/diContainer';
import serviceNames from '~setup/CommunicationsService';
import { events, emit } from '@estee/elc-service-bus';

export interface IPayload {
    email: string;
    source: string;
}
export class UserProfileChangedUseCase {
    private emailOptInRepository: EmailOptInRepository;
    private payload: IPayload;

    constructor(payload: IPayload) {
        this.emailOptInRepository = diContainer.get(serviceNames.emailOptInRepository);

        this.payload = payload;
    }

    public execute = async () => {
        try {
            await this.emailOptInRepository.updateEmailOptInRequest(this.payload);
        } catch (error) {
            emit(events.SAVE_FOR_LATER_UPDATE_FAILED, error);
            console.error(error);
        }
    };
}
